import React, { FunctionComponent, useEffect, useState } from 'react';
import { article, host } from '@Api';
import { message } from 'antd';
import cx from 'classnames';
import styles from './fixedRank.module.less';

interface IProps {
  current: string;
}

interface rankPorps {
  name: string
  rank: number
  selected: number
}

interface rankDataType {
  total: number;
  '0to100Accelerate': rankPorps[];
  '30kmVibrationComfort': rankPorps[];
  '60kmVibrationComfort': rankPorps[];
  '100to0Brake': rankPorps[];
  'cityFuelConsumption': rankPorps[];
  'highSpeedFuelConsumption': rankPorps[];
  'speedway': rankPorps[];
}

const keyMap = {
  '0to100Accelerate': '加速成績',
  '30kmVibrationComfort': '30km/h震動舒適度排名',
  '60kmVibrationComfort': '60km/h震動舒適度排名',
  '100to0Brake': '100-0km/h煞停距離排名',
  'cityFuelConsumption': '市區油耗排名',
  'highSpeedFuelConsumption': '高速油耗排名',
  'speedway': '賽道成績排名'
}

const { imageNew } = host

const { fetchLike, fetchSuperTestRank, fetchComment } = article;

const Right: FunctionComponent<IProps> = ({ current }) => {
  const [index, setIndex] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);
  const [text, setText] = useState<string>('');
  const [rankData, setData] = useState<rankDataType>({
    total: 0,
    '0to100Accelerate': [],
    '30kmVibrationComfort': [],
    '60kmVibrationComfort': [],
    '100to0Brake': [],
    'cityFuelConsumption': [],
    'highSpeedFuelConsumption': [],
    'speedway': []
  })

  const initTop = () => {
    const WHeight = window.innerHeight;

    setHeight(WHeight - 428);
  }

  const fetchRank = async () => {
    const res = await fetchSuperTestRank({ myids: window.ARTICLE_MYIDS });

    if (res && res.status === 12000) {
      setData(res.data);
    }
  }

  const like = async (action: string, inx: number) => {
    const res = await fetchLike({ model: 'superTest', id: window.article_id, action, drivice_id: localStorage.getItem('uuid') })

    if (res && res.status === 12000) {
      setIndex(inx);
      localStorage.setItem('superTestLike', `${localStorage.getItem('uuid')},${index}`);
      return
    }
    message.info(res.data.message);
  }

  const submit = async () => {
    const res = await fetchComment({ type: 'super_test', content: text })

    if (res && res.status === 12000) {
      setText('');
      message.info('提交成功');
      return
    }
    message.info(res.data.message);
  }

  useEffect(() => {
    const res = localStorage.getItem('superTestLike');

    if (res) {
      const str = res.split(',')?.[1];

      Number(str) !== NaN && setIndex(Number(str));
    }
  }, [])

  useEffect(() => {
    if (!current || !rankData?.[current]) { };

  }, [current])

  useEffect(() => {
    initTop();
    fetchRank();

    window.addEventListener('resize', initTop);

    return () => {
      window.removeEventListener('resize', initTop);
    }
  }, [])

  return (
    <>
      <div className={styles['supertest-evaluate']} style={{ top: height }}>
        <h4>改版評價</h4>
        <p className={styles['evaluate-tip']}>請對本次超級測試文章改版優化進行評分或評價～</p>
        <div className={styles['evaluate']}>
          <div className={styles['evaluate-icon']}>
            <img src={`${imageNew}/article/superTest/${index === 1 ? 8 : 6}.png`} onClick={() => index !== 1 && like('like', 1)} alt="" />
            <p>好評鼓勵一下</p>
          </div>
          <div className={styles['evaluate-icon']}>
            <img src={`${imageNew}/article/superTest/${index === 2 ? 9 : 7}.png`} onClick={() => index !== 2 && like('unlike', 2)} alt="" />
            <p>對我幫助不大</p>
          </div>
        </div>
        <div className={styles['evaluate-comment']}>
          <h4>留言專區</h4>
          <textarea maxLength={100} value={text} onChange={e => setText(e.target.value)} placeholder="請留下您的寶貴建議"></textarea>
          <button
            type="button"
            className={text.length > 0 && styles['useable']}
            disabled={text.length === 0}
            onClick={() => submit()}
          >提交</button>
        </div>
      </div>
      <div className={styles["fixed-rank"]}>
        {
          (current && rankData?.[current]) &&
          (
            current !== 'cityFuelConsumption' ?
            <div className={styles['rank']}>
              <div className={styles['top']}>
                <h3>{keyMap[current]}</h3>
                <span>共測{rankData.total}台</span>
              </div>
              <div className={styles['rank-list']}>
                {
                  rankData?.[current].map((item, inx) => (
                    item.selected === 1 && item.rank > inx + 1 ?
                      <>
                        <div className={styles['place']}>...</div>
                        <div className={cx(styles['rank-item'], {[styles['rank-select']]: item.selected === 1 })} key={inx}>
                          <span className={cx(styles['rank-num'], {[styles[`rank-${inx + 1}`]]: inx < 3})}>{item.rank}</span>
                          {item.name}
                        </div>
                      </>
                      :
                      <div className={cx(styles['rank-item'], {[styles['rank-select']]: item.selected === 1 })} key={inx}>
                        <span className={cx(styles['rank-num'], {[styles[`rank-${inx + 1}`]]: inx < 3})}>{item.rank}</span>
                        {item.name}
                      </div>
                  ))
                }
              </div>
              <div className={styles['see']}>查看完整排名</div>
            </div> :
            <>
              <div className={styles['rank']}>
                <div className={styles['top']}>
                  <h3>{keyMap[current]}</h3>
                  <span>共測{rankData.total}台</span>
                </div>
                <div className={styles['rank-list']}>
                  {
                    rankData?.[current].map((item, inx) => (
                      item.selected === 1 && item.rank > inx + 1 ?
                        <>
                          <div className={styles['place']}>...</div>
                          <div  className={cx(styles['rank-item'], {[styles['rank-select']]: item.selected === 1 })} key={inx}>
                            <span className={cx(styles['rank-num'], {[styles[`rank-${inx + 1}`]]: inx < 3})}>{item.rank}</span>
                            {item.name}
                          </div>
                        </>
                        :
                        <div  className={cx(styles['rank-item'], {[styles['rank-select']]: item.selected === 1 })} key={inx}>
                          <span className={cx(styles['rank-num'], {[styles[`rank-${inx + 1}`]]: inx < 3})}>{item.rank}</span>
                          {item.name}
                        </div>
                    ))
                  }
                </div>
                <div className={styles['see']}>查看完整排名</div>
              </div>
              {
                rankData?.['highSpeedFuelConsumption'] &&
                <div className={styles['rank']}>
                  <div className={styles['top']}>
                    <h3>{keyMap['highSpeedFuelConsumption']}</h3>
                    <span>共測{rankData.total}台</span>
                  </div>
                  <div className={styles['rank-list']}>
                    {
                      rankData?.['highSpeedFuelConsumption'].map((item, inx) => (
                        item.selected === 1 && item.rank > inx + 1 ?
                          <>
                            <div className={styles['place']}>...</div>
                            <div className={cx(styles['rank-item'], {[styles['rank-select']]: item.selected === 1 })} key={inx}>
                              <span className={cx(styles['rank-num'], {[styles[`rank-${inx + 1}`]]: inx < 3})}>{item.rank}</span>
                              {item.name}
                            </div>
                          </>
                          :
                          <div className={cx(styles['rank-item'], {[styles['rank-select']]: item.selected === 1 })} key={inx}>
                            <span className={cx(styles['rank-num'], {[styles[`rank-${inx + 1}`]]: inx < 3})}>{item.rank}</span>
                            {item.name}
                          </div>
                      ))
                    }
                  </div>
                  <div className={styles['see']}>查看完整排名</div>
                </div>
              }
            </>
          )
        }
      </div>
    </>
  )
}

export default Right;
